import { reportTypes } from '../reports/Reports.constants';
import type { Assay } from './Labmatrix.types';

/* eslint-disable @typescript-eslint/naming-convention */
export const dataColNames = [
  'Biomaterial Name',
  'Availability',
  'Current Status',
  'Type',
  'Subtype/Derivative',
  'Passage',
  'Quantity',
  'Process',
  'Clinical Age (CURRENT, calculated',
  'Clinical Age (from biomaterial form)',
  'Collection Date',
  'Preservation Date',
  'Specimen Purpose',
  'Processing Date',
  'Container Type',
  'Storage Location',
  'Study Code',
  'Specimen Purpose',
  'Barcode',
  'Biomaterial ID',
  'Date Sent for Sequencing',
  'Event',
] as const;

export const specimenPurposes = [
  'Germline - donor',
  'Germline - patient',
  'Liquid Biopsy',
  'TB Banked',
  'TB ZERO Potentials',
  'Tumour',
] as const;

// the values is the name of the field in labmatrix
// the key is the name of the field in the database
export const lbAssays = {
  WGS_Only: 'WGS Only',
  Low_pass_NGS: 'Low pass NGS',
  LB_Panel: 'LB Panel',
  Olink: 'Olink',
  MACSima: 'MACSima',
  Xenium: 'Xenium',
  'H&E': 'H&E',
  Flow: 'Flow',
  ddPCR: 'ddPCR',
  STAMP: 'STAMP',
  short_scRNASeq: 'short_scRNASeq',
  long_scRNASeq: 'long_scRNASeq',
  LB_Germline_WGS: 'LB Germline WGS',
  LB_Tumour_WGS: 'LB Tumour WGS',
} as const;
export const lbAssayValues = Object.keys(lbAssays) as Assay[];

export const subtypes = [
  'Blood Clot',
  'Buffy coat',
  'Capture library',
  'Cell Plug',
  'Cells',
  'cfDNA',
  'Cryo-Preserved',
  'DNA',
  'FFPE Block',
  'Fresh Sample',
  'Frozen Sample',
  'Granulocytes',
  'MNC',
  'NGS Library',
  'PBMC',
  'Pellet',
  'Plasma',
  'Primary cell culture',
  'Protein',
  'RBC Lysed Pellet',
  'RNA',
  'Serum',
  'Supernatant',
  'Unstained Slides',
  'Whole',
  'Xenograft',
  'Xenograft - Cell Plug',
  'Xenograft - Cells',
  'Xenograft - Whole',
] as const;

export const inventoryStatuses = [
  'Exhausted',
  'In Inventory',
  'Destroyed',
  'Transferred',
  'For aliquoting',
  'In Transit',
  'Lost',
  'Reserved',
] as const;

// Entity types that Labmatrix accepts file attachments against.
// See POST /api/:type/:id/attachments in the Chameleon REST API docs.
export const labmatrixAttachmentEntities = ['Subject', 'Biomaterial'] as const;

// The Labmatrix form that finalised ZERO2 reports are filed against. This is the
// form's External ID, which Labmatrix sets to the form name on creation — if the form
// is ever renamed in the Administration Console the External ID does not follow, so
// this value must match the External ID rather than the display name.
export const LABMATRIX_REPORT_FORM = 'CCI Confidential Attachment';

// Values for the form's `Type` field, per ZeroDash report type. Note MTB is the one
// entry without the "ZERO2" prefix — that is how Labmatrix expects it.
export const labmatrixReportAttachmentTypes = {
  MOLECULAR_REPORT: 'ZERO2 Molecular Report',
  GERMLINE_REPORT: 'ZERO2 Germline Report',
  PRECLINICAL_REPORT: 'ZERO2 Preclinical Report',
  MTB_REPORT: 'MTB Report',
} as const satisfies Record<typeof reportTypes[number], string>;
